<div class="page-container">
  <main class="page-main">
    <div class="page-content full-height">
      <!-- Header Section -->
      <div class="page-title-container">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="page-title">Clients & Matters</h1>
      </div>

      <!-- Search Section -->
      <mat-card class="filters-card">
        <mat-card-content>
          <form [formGroup]="filterForm" class="filters-form">
            <div class="main-search-row">
              <div class="search-field-with-mode">
                <mat-form-field appearance="outline" class="search-mode-field">
                  <mat-select formControlName="searchMode">
                    <mat-option value="client">Client</mat-option>
                    <mat-option value="billingPartner"
                      >Billing Partner</mat-option
                    >
                    <mat-option value="matterTitle">Matter Title</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="filter-field search-field"
                >
                  <mat-label>{{ searchLabel }}</mat-label>
                  <input
                    matInput
                    formControlName="searchTerm"
                    [placeholder]="searchPlaceholder"
                    autocomplete="off"
                    (keyup.enter)="onEnterKeySearch()"
                  />
                  <mat-icon
                    matSuffix
                    [style.cursor]="
                      filterForm.get('searchTerm')?.value
                        ? 'pointer'
                        : 'default'
                    "
                    (click)="
                      filterForm.get('searchTerm')?.value ? clearSearch() : null
                    "
                    >{{
                      filterForm.get("searchTerm")?.value ? "close" : "search"
                    }}</mat-icon
                  >
                </mat-form-field>
              </div>
              <button
                mat-stroked-button
                class="reset-filters-btn"
                type="button"
                (click)="resetFilters()"
                [disabled]="!hasFiltersChanged()"
              >
                <mat-icon>replay</mat-icon>
                Reset
              </button>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      <!-- Results Section -->
      <mat-card class="table-card no-padding">
        <div class="clients-table-container">
          <!-- Landing Page -->
          @if (showLandingPage) {
            <div class="landing-top">
              <div class="landing-welcome">
                <i class="material-symbols-outlined landing-icon">business</i>
                <h3>Welcome to Clients & Matters</h3>
                <p>
                  Search for a client by name or number, by billing partner, or
                  by matter title.
                </p>
              </div>
            </div>
            <div class="landing-bottom">
              @if (isLoadingRecentMatters || recentlyViewedMatters.length > 0) {
                <div class="recently-viewed-section">
                  <h4>Recently Viewed Matters</h4>
                  <table
                    mat-table
                    [dataSource]="
                      isLoadingRecentMatters
                        ? getSkeletonRecentMatters()
                        : recentlyViewedMatters
                    "
                    class="recently-viewed-table"
                  >
                    <!-- Client-Matter Number Column -->
                    <ng-container matColumnDef="clientMatterNumber">
                      <th mat-header-cell *matHeaderCellDef>Number</th>
                      <td mat-cell *matCellDef="let history">
                        @if (history.id < 0) {
                          <div class="skeleton-line short"></div>
                        } @else {
                          <a
                            href=""
                            class="cell-link"
                            (click)="
                              $event.preventDefault();
                              navigateToMatter(
                                history.matter.clientMatterNumber,
                                $event
                              )
                            "
                            >{{ history.matter.clientMatterNumber }}</a
                          >
                        }
                      </td>
                    </ng-container>

                    <!-- Client Column -->
                    <ng-container matColumnDef="client">
                      <th mat-header-cell *matHeaderCellDef>Client</th>
                      <td mat-cell *matCellDef="let history">
                        @if (history.id < 0) {
                          <div class="skeleton-line medium"></div>
                        } @else {
                          {{ history.client?.clientName || "N/A" }}
                        }
                      </td>
                    </ng-container>

                    <!-- Matter Title Column -->
                    <ng-container matColumnDef="title">
                      <th mat-header-cell *matHeaderCellDef>Matter</th>
                      <td mat-cell *matCellDef="let history">
                        @if (history.id < 0) {
                          <div class="skeleton-line long"></div>
                        } @else {
                          {{ history.matter.matterName }}
                        }
                      </td>
                    </ng-container>

                    <!-- Region Column -->
                    <ng-container matColumnDef="region">
                      <th mat-header-cell *matHeaderCellDef>Region</th>
                      <td mat-cell *matCellDef="let history">
                        @if (history.id < 0) {
                          <div class="skeleton-line medium"></div>
                        } @else {
                          {{ history.client?.state || "N/A" }}
                        }
                      </td>
                    </ng-container>

                    <!-- Last Viewed Column -->
                    <ng-container matColumnDef="lastViewed">
                      <th mat-header-cell *matHeaderCellDef>Last Viewed</th>
                      <td mat-cell *matCellDef="let history">
                        @if (history.id < 0) {
                          <div class="skeleton-line short"></div>
                        } @else {
                          {{ history.accessedAt | date: "short" }}
                        }
                      </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="actions-cell"
                      >
                        Actions
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let history"
                        class="actions-cell"
                        (click)="$event.stopPropagation()"
                      >
                        @if (history.id >= 0) {
                          <div class="actions-cell-inner">
                            <button
                              mat-icon-button
                              class="action-btn"
                              matTooltip="View matter details"
                              (click)="
                                navigateToMatter(
                                  history.matter.clientMatterNumber,
                                  $event
                                )
                              "
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>
                            @if (isComparisonPopUpsEnabled) {
                              <button
                                mat-icon-button
                                class="action-btn"
                                matTooltip="Open in floating window"
                                (click)="
                                  openMatterInFloatingDialog(
                                    history.matter,
                                    $event
                                  )
                                "
                              >
                                <mat-icon>select_window_2</mat-icon>
                              </button>
                            }
                          </div>
                        }
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="recentMatterColumns"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: recentMatterColumns"
                      class="matter-row"
                    ></tr>
                  </table>
                </div>
              } @else {
                <p class="empty-history-message">
                  Your most recently viewed matters will appear here.
                </p>
              }
            </div>
          }

          <!-- Searching State: Skeleton Cards -->
          @if (isSearching) {
            <div class="clients-cards-container">
              @for (i of [1, 2, 3, 4, 5]; track i) {
                <mat-card class="client-card">
                  <mat-card-header class="client-header-clickable">
                    <div class="client-header">
                      <div class="expand-indicator">
                        <mat-icon>keyboard_arrow_right</mat-icon>
                      </div>
                      <div class="client-info">
                        <h3 class="client-name">
                          <span
                            class="skeleton-line"
                            style="width: 200px"
                          ></span>
                        </h3>
                        <span class="client-meta">
                          <span class="skeleton-line medium"></span>
                        </span>
                      </div>
                    </div>
                  </mat-card-header>
                </mat-card>
              }
            </div>
          }

          <!-- Error State -->
          @if (error && !isSearching) {
            <app-error-state
              [message]="error"
              (retry)="retry()"
            ></app-error-state>
          }

          <!-- Empty State -->
          @if (
            !isSearching && !error && !showLandingPage && clients.length === 0
          ) {
            <div class="empty-state">
              <mat-icon class="empty-icon">business</mat-icon>
              <h3>No clients found</h3>
              <p>
                {{
                  searchMode === "billingPartner"
                    ? "No matters found for that billing partner."
                    : searchMode === "matterTitle"
                      ? "No matters found matching that title."
                      : "Try adjusting your search term."
                }}
              </p>
            </div>
          }

          <!-- Client Results -->
          @if (
            !isSearching && !error && !showLandingPage && clients.length > 0
          ) {
            <div class="clients-cards-container">
              @for (client of clients; track client.clientNumber) {
                <mat-card
                  class="client-card"
                  [class.expanded]="isExpanded(client)"
                >
                  <mat-card-header
                    class="client-header-clickable"
                    (click)="toggleClient(client, $event)"
                    [attr.aria-label]="
                      'Toggle matters for ' + client.clientName
                    "
                    role="button"
                    tabindex="0"
                    (keydown.enter)="toggleClient(client, $event)"
                    (keydown.space)="toggleClient(client, $event)"
                  >
                    <div class="client-header">
                      <div class="expand-indicator">
                        <mat-icon [class.rotated]="isExpanded(client)">
                          {{
                            isExpanded(client)
                              ? "keyboard_arrow_up"
                              : "keyboard_arrow_right"
                          }}
                        </mat-icon>
                      </div>
                      <div class="client-info">
                        <h3 class="client-name">
                          @if (loadingClientDetails && !client.clientName) {
                            #{{ client.clientNumber }} -
                            <span class="skeleton-line short"></span>
                          } @else {
                            {{ getClientDisplayName(client) }}
                          }
                        </h3>
                        <span class="client-meta">
                          @if (loadingClientDetails && !client.clientName) {
                            <span class="skeleton-line medium"></span>
                          } @else {
                            @if (client.industryDescription) {
                              {{ client.industryDescription }}
                            }
                            @if (client.industryDescription && client.state) {
                              &middot;
                            }
                            @if (client.state) {
                              {{ client.state }}
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </mat-card-header>

                  <!-- Matters Section (expanded) -->
                  @if (isExpanded(client)) {
                    <mat-card-content class="matters-content">
                      <!-- Loading matters -->
                      @if (isLoadingMattersFor(client.clientNumber)) {
                        <div class="matters-list skeleton-matters">
                          @for (i of [1, 2, 3, 4, 5]; track i) {
                            <div class="matter-item">
                              <div class="matter-row">
                                <div class="matter-cell matter-number-cell">
                                  <span
                                    class="skeleton-line"
                                    style="width: 90px"
                                  ></span>
                                </div>
                                <div class="matter-cell matter-title-cell">
                                  <span class="skeleton-line long"></span>
                                </div>
                                <div class="matter-cell">
                                  <span class="skeleton-line medium"></span>
                                </div>
                                <div class="matter-cell">
                                  <span class="skeleton-line short"></span>
                                </div>
                                <div
                                  class="matter-cell matter-actions-cell"
                                ></div>
                              </div>
                            </div>
                          }
                        </div>
                      }

                      <!-- Matter load error -->
                      @if (getMatterError(client.clientNumber)) {
                        <div class="matters-error">
                          <span>{{ getMatterError(client.clientNumber) }}</span>
                          <button
                            mat-stroked-button
                            (click)="
                              retryLoadMatters(client.clientNumber, $event)
                            "
                          >
                            Retry
                          </button>
                        </div>
                      }

                      <!-- No matters -->
                      @if (
                        !isLoadingMattersFor(client.clientNumber) &&
                        !getMatterError(client.clientNumber) &&
                        getMattersForClient(client.clientNumber).length === 0
                      ) {
                        <div class="matters-empty">
                          <span>No matters found for this client.</span>
                        </div>
                      }

                      <!-- Matters list -->
                      @if (
                        !isLoadingMattersFor(client.clientNumber) &&
                        !getMatterError(client.clientNumber) &&
                        getMattersForClient(client.clientNumber).length > 0
                      ) {
                        <!-- Matter Table Header -->
                        <div class="matter-table-header">
                          <div
                            class="matter-header-cell sortable"
                            (click)="
                              onMatterSortChange(
                                client.clientNumber,
                                'matterNumber'
                              )
                            "
                            [class.active-sort]="
                              getMatterSortDirection(
                                client.clientNumber,
                                'matterNumber'
                              ) !== null
                            "
                          >
                            <span class="header-text"
                              >Client Matter Number</span
                            >
                            @if (
                              getMatterSortDirection(
                                client.clientNumber,
                                "matterNumber"
                              )
                            ) {
                              <mat-icon class="sort-icon">
                                {{
                                  getMatterSortDirection(
                                    client.clientNumber,
                                    "matterNumber"
                                  ) === "desc"
                                    ? "arrow_upward"
                                    : "arrow_downward"
                                }}
                              </mat-icon>
                            }
                          </div>
                          <div
                            class="matter-header-cell sortable"
                            (click)="
                              onMatterSortChange(client.clientNumber, 'title')
                            "
                            [class.active-sort]="
                              getMatterSortDirection(
                                client.clientNumber,
                                'title'
                              ) !== null
                            "
                          >
                            <span class="header-text">Title</span>
                            @if (
                              getMatterSortDirection(
                                client.clientNumber,
                                "title"
                              )
                            ) {
                              <mat-icon class="sort-icon">
                                {{
                                  getMatterSortDirection(
                                    client.clientNumber,
                                    "title"
                                  ) === "desc"
                                    ? "arrow_upward"
                                    : "arrow_downward"
                                }}
                              </mat-icon>
                            }
                          </div>
                          <div
                            class="matter-header-cell sortable"
                            (click)="
                              onMatterSortChange(
                                client.clientNumber,
                                'industry'
                              )
                            "
                            [class.active-sort]="
                              getMatterSortDirection(
                                client.clientNumber,
                                'industry'
                              ) !== null
                            "
                          >
                            <span class="header-text">Industry</span>
                            @if (
                              getMatterSortDirection(
                                client.clientNumber,
                                "industry"
                              )
                            ) {
                              <mat-icon class="sort-icon">
                                {{
                                  getMatterSortDirection(
                                    client.clientNumber,
                                    "industry"
                                  ) === "desc"
                                    ? "arrow_upward"
                                    : "arrow_downward"
                                }}
                              </mat-icon>
                            }
                          </div>
                          <div
                            class="matter-header-cell sortable"
                            (click)="
                              onMatterSortChange(client.clientNumber, 'region')
                            "
                            [class.active-sort]="
                              getMatterSortDirection(
                                client.clientNumber,
                                'region'
                              ) !== null
                            "
                          >
                            <span class="header-text">Region</span>
                            @if (
                              getMatterSortDirection(
                                client.clientNumber,
                                "region"
                              )
                            ) {
                              <mat-icon class="sort-icon">
                                {{
                                  getMatterSortDirection(
                                    client.clientNumber,
                                    "region"
                                  ) === "desc"
                                    ? "arrow_upward"
                                    : "arrow_downward"
                                }}
                              </mat-icon>
                            }
                          </div>
                          <div class="matter-header-cell matter-actions-header">
                            <span class="header-text"></span>
                          </div>
                        </div>

                        <div class="matters-list">
                          @for (
                            matter of getPagedMatters(client.clientNumber);
                            track matter.clientMatterNumber
                          ) {
                            <div class="matter-item">
                              <div class="matter-row">
                                <div class="matter-cell matter-number-cell">
                                  <a
                                    href=""
                                    class="cell-link"
                                    (click)="
                                      $event.preventDefault();
                                      navigateToMatter(
                                        matter.clientMatterNumber,
                                        $event
                                      )
                                    "
                                    >{{ matter.clientMatterNumber }}</a
                                  >
                                </div>
                                <div class="matter-cell matter-title-cell">
                                  <h4 class="matter-title">
                                    {{ matter.matterName }}
                                  </h4>
                                </div>
                                <div class="matter-cell">
                                  @if (
                                    loadingClientDetails && !client.clientName
                                  ) {
                                    <span class="skeleton-line medium"></span>
                                  } @else {
                                    <span class="field-value">{{
                                      client.industryDescription || "N/A"
                                    }}</span>
                                  }
                                </div>
                                <div class="matter-cell">
                                  @if (
                                    loadingClientDetails && !client.clientName
                                  ) {
                                    <span class="skeleton-line short"></span>
                                  } @else {
                                    <span class="field-value">{{
                                      client.state || "N/A"
                                    }}</span>
                                  }
                                </div>
                                <div class="matter-cell matter-actions-cell">
                                  <button
                                    mat-icon-button
                                    class="action-btn"
                                    matTooltip="View matter details"
                                    (click)="
                                      navigateToMatter(
                                        matter.clientMatterNumber,
                                        $event
                                      )
                                    "
                                  >
                                    <mat-icon>visibility</mat-icon>
                                  </button>
                                  @if (isComparisonPopUpsEnabled) {
                                    <button
                                      mat-icon-button
                                      class="action-btn"
                                      matTooltip="Open in floating window"
                                      (click)="
                                        openMatterInFloatingDialog(
                                          matter,
                                          $event
                                        )
                                      "
                                    >
                                      <mat-icon>select_window_2</mat-icon>
                                    </button>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        @if (
                          getMattersForClient(client.clientNumber).length >=
                          matterPageSize
                        ) {
                          <mat-paginator
                            class="matters-paginator"
                            [length]="
                              getMattersForClient(client.clientNumber).length
                            "
                            [pageSize]="getMatterPageSize(client.clientNumber)"
                            [pageIndex]="
                              getMatterPageIndex(client.clientNumber)
                            "
                            [pageSizeOptions]="matterPageSizeOptions"
                            showFirstLastButtons
                            (page)="
                              onMatterPageChange(client.clientNumber, $event)
                            "
                          ></mat-paginator>
                        }
                      }
                    </mat-card-content>
                  }
                </mat-card>
              }
            </div>
            @if (totalCount > 0) {
              <mat-paginator
                [length]="totalCount"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="[5, 10, 25, 50]"
                showFirstLastButtons
                (page)="onPageChange($event)"
              ></mat-paginator>
            }
          }
        </div>
      </mat-card>
    </div>
  </main>
</div>
